module.exports = "https://venezia-network.servercdn.it/static/fonts/FuturaPT-Demi.eot?779ccc41167f93f049dc96c2d75dd782";